import { Component, ElementRef, ViewChild } from '@angular/core';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from '../../../Shared/shared-imports';
import { Posvendoradjustmentservice } from '../../../services/PosVendorAdjustment.service';
import { GeneralService } from '../../../services/general.service';
import { VendorService } from '../../../services/Vendor.service';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { VendorSearchComponent } from 'src/app/Shared/vendor-search/vendor-search.component';
import { Subscription } from 'rxjs';
import { FilterService, GridComponent } from '@syncfusion/ej2-angular-grids';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import '@angular/localize/init';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';
import { EActionTypes, EToaster, EUserSecurityFunctionID } from "src/app/Shared/enum";
import { IUserPermissionHandler } from "src/app/Shared/model/CommonModel";
import { UserPermissionHandlerDirective } from "src/app/Shared/userPermissionHandler.directive";
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { take } from 'rxjs';
import { IPOSTerminal } from 'src/app/Shared/Interfaces/IPOSSettings';
import { UserService } from 'src/app/services/User.service';
import { PosOpeningCashDrawerService } from 'src/app/services/pos_OpeningCashDrawer.service';
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-ops-vendor-adjustments',
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, OperationsComponent, TopBarComponent, VendorSearchComponent, WordReplacePipe, UserPermissionHandlerDirective, LoaderComponent],
  standalone: true,
  providers: [FilterService],
  templateUrl: './ops-vendor-adjustments.html',
  styleUrl: './ops-vendor-adjustments.scss'

})

export class OpsVendorAdjustments {

  logoPreviewUrl: string = './assets/images/NoPhoto.svg';
  @ViewChild('gridPosVendorAdjustment', { static: false }) public gridPosVendorAdjustment: GridComponent;
  @ViewChild('vendorAdjustmentModal', { static: false }) vendorAdjustmentModal: ElementRef;

  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.VendorAdjustments, Action: EActionTypes.VIEW };
  createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.VendorAdjustments, Action: EActionTypes.CREATE };
  deletePermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.VendorAdjustments, Action: EActionTypes.DELETE };
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.VendorAdjustments, Action: EActionTypes.EDIT };

  constructor(private posvendoradjustmentservice: Posvendoradjustmentservice,
    private formbuilder: FormBuilder,
    private toastr: ToastrService,
    private userService: UserService,
    private router: Router,
    private posOpeningCashDrawerService: PosOpeningCashDrawerService,
    private vendorService: VendorService,
    private generalService: GeneralService,
    private wordReplacePipe: WordReplacePipe,
    private customCurrency: customCurrencyPipe,
    private sharedHTMLSettings: SharedHTMLSettingsDataService) {

    this.VendorAdjustmentForm = this.formbuilder.group({
      AdjId: ['',],
      marketVendorId: ['', Validators.required],
      vendorSeqId: ['',],
      vendorName: [{ value: '', disabled: true }],
      cashPayment: [this.customCurrency.transform('0.00'), [Validators.required, Validators.min(0)]],
      checkPayment: [this.customCurrency.transform('0.00'), [Validators.required, Validators.min(0)]],
      checkNumber: [{ value: '', disabled: true }],
      totalAmount: [{ value: this.customCurrency.transform('0.00'), disabled: true }],
      actionType: ['', Validators.required],
      dateEntry: [new Date(), Validators.required],
      description: ['', Validators.required],
      terminalName: [''],
      userName: ['']
    });
  }

  VendorFilterOption = {
    All: true,
    Current: false,
    Inactive: false,
    PageModel: {
      pageCount: 1,
      pageSize: 20
    }
  };

  isCollapsed = true;
  paymentData: any[] = [];
  private subscriptions: Subscription[] = [];
  VendorAdjustmentForm: FormGroup;
  isEditMode = false;
  loaderIcon: Promise<boolean> = Promise.resolve(false);
  posTerminals: IPOSTerminal[] = [];
  selectedTerminal = '';
  userName = '';

  ngOnInit(): void {
    this.userName = this.userService.getLoggedInUserName();
    this.getPosVendorAdjDetails();
    this.setupAmountCalculation();
    this.getPOSTerminals();
    this.VendorAdjustmentForm.get('checkPayment')?.valueChanges
      .subscribe(() => this.enableDisableCheckNumber());
  }

  getPosVendorAdjDetails() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(
      this.posvendoradjustmentservice.getPosVendorAdjDetails().subscribe(
        (res: any[]) => {
          if (res) {
            const mapped = res.map((el: any, index: number) => ({
              SlNo: index + 1,
              AdjId: el.AdjID || '',
              DealerID: el.MarketVendorId,
              VendorSeqID: el.vendorId,
              DealerName: el.VendorName ?? '',
              CashPayment: this.customCurrency.transform(el.Cash ?? 0),
              CheckPayment: this.customCurrency.transform(el.Check ?? 0),
              CheckNo: el.CheckNo ?? '',
              TotalPayment: this.customCurrency.transform((el.Cash ?? 0) + (el.Check ?? 0)),
              ActionType: el.ActionType === 1 ? 'Credit' : 'Debit',
              Description: el.Description ?? '',
              PCName: el.PCName,
              UserName: el.UserName
            }));
            this.paymentData = mapped;
          }
          this.loaderIcon = Promise.resolve(false);
        },
        (err) => {
          this.toastr.error(`Failed to fetch ${this.fieldName} adjustments.`, 'Error');
          this.loaderIcon = Promise.resolve(false);
        }
      )
    );
  }

  getPOSTerminals() {
    this.subscriptions.push(this.posOpeningCashDrawerService.getPOSTerminals()
      .pipe(take(1))
      .subscribe({
        next: (response: IPOSTerminal[]) => {
          if (response) {
            this.posTerminals = response;
            this.getDefaultTerminalId();
          }
        },
        error: () => {
          this.toastr.error(
            EToaster.MsgErrorFetch + $localize`:@@POSTerminal:POS Terminal`,
            EToaster.TitleError,
            this.sharedHTMLSettings.ToasterConfig
          );
        }
      }));
  }

  getDefaultTerminalId() {
    this.subscriptions.push(this.userService.getDefaultTerminalId()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          const terminalObj = this.posTerminals.find(x => x.Id === res);
          this.selectedTerminal = terminalObj?.Name ?? '';
        }
      }));
  }

  resetVendorAdjustmentForm(): void {
    this.VendorAdjustmentForm.reset({
      marketVendorId: '',
      vendorSeqId: '',
      vendorName: '',
      cashPayment: this.customCurrency.transform('0.00'),
      checkPayment: this.customCurrency.transform('0.00'),
      checkNumber: '',
      totalAmount: this.customCurrency.transform('0.00'),
      actionType: '',
      dateEntry: new Date(),
      description: '',
      terminalName: this.selectedTerminal,
      userName: this.userName
    });
    this.VendorAdjustmentForm.get('marketVendorId')?.enable();
  }

  onRowSelected(event: any): void {
    if (!this.editRight) {
      this.toastr.info(
        EToaster.MsgInfoNoRightToEdit + $localize`:@@VendorAdjustments:${this.fieldName} Adjustments`,
        EToaster.TitleInfo,
        this.sharedHTMLSettings.ToasterConfig
      );
      return;
    }
    this.isEditMode = true;
    this.getPosVendorAdjDetails();
    const data = event.data;
    console.log('Selected Row:', data);
    this.VendorAdjustmentForm.patchValue({
      AdjId: data.AdjId,
      marketVendorId: data.DealerID,
      vendorSeqId: data.VendorSeqID,
      vendorName: data.DealerName,
      cashPayment: data.CashPayment,
      checkPayment: data.CheckPayment,
      checkNumber: data.CheckNo,
      totalAmount: data.TotalPayment,
      actionType: data.ActionType === 'Credit' ? 1 : 0,
      dateEntry: new Date(),
      description: data.Description ?? '',
      terminalName: data.PCName?.trim() ? data.PCName : this.selectedTerminal,
      userName: data.UserName?.trim() ? data.UserName : this.userName
    });
    this.VendorAdjustmentForm.get('marketVendorId')?.disable();
    this.VendorAdjustmentForm.markAsPristine();
    const modal = new bootstrap.Modal(this.vendorAdjustmentModal.nativeElement, {
      backdrop: 'static',
      keyboard: false,
      focus: true
    });
    modal.show();
  }

  saveVendorAdjustment(): void {
    if (this.VendorAdjustmentForm.invalid) {
      this.VendorAdjustmentForm.markAllAsTouched();
      return;
    }

    const cleanCurrency = (val: any) =>
      parseFloat(String(val).replace(/[^0-9.]/g, '')) || 0;

    const obj = {
      AdjId: this.VendorAdjustmentForm.get('AdjId')?.value,
      VendorId: this.VendorAdjustmentForm.get('vendorSeqId')?.value,
      VendorName: this.VendorAdjustmentForm.get('vendorName')?.value,
      Cash: cleanCurrency(this.VendorAdjustmentForm.get('cashPayment')?.value),
      Check: cleanCurrency(this.VendorAdjustmentForm.get('checkPayment')?.value),
      CheckNo: this.VendorAdjustmentForm.get('checkNumber')?.value,
      AdjAmt: cleanCurrency(this.VendorAdjustmentForm.get('totalAmount')?.value),
      ActionType: this.VendorAdjustmentForm.get('actionType')?.value,
      AdjDateTime: new Date().toISOString(),
      Description: this.VendorAdjustmentForm.get('description')?.value,
      EnteredDtTime: this.VendorAdjustmentForm.get('dateEntry')?.value,
      PCName: this.VendorAdjustmentForm.get('terminalName')?.value,
      UserName: this.VendorAdjustmentForm.get('userName')?.value
    };

    Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Are you sure you want to save this adjustment?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.subscriptions.push(
          this.posvendoradjustmentservice.saveVendorAdjustment(obj).subscribe({
            next: (response) => {
              this.toastr.success(`${this.fieldName} adjustment saved successfully.`, 'Saved!', this.sharedHTMLSettings.ToasterConfig);
              this.getPosVendorAdjDetails();
              this.resetVendorAdjustmentForm();
              this.VendorAdjustmentForm.markAsPristine();
              const modalInstance = bootstrap.Modal.getInstance(
                this.vendorAdjustmentModal.nativeElement
              );
              modalInstance?.hide();
            },
            error: (err) => {
              console.error('Save failed:', err);
              this.toastr.error(`Failed to save ${this.fieldName} adjustment.`, 'Error', this.sharedHTMLSettings.ToasterConfig);
            },
          })
        );
      }
    });
  }

  onNewClick() {
    this.isEditMode = false;
    this.getPosVendorAdjDetails();
    this.resetVendorAdjustmentForm();
    this.VendorAdjustmentForm.patchValue({
      terminalName: this.selectedTerminal,
      userName: this.userName
    });
    this.updateTotalAmount();
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const modal = new bootstrap.Modal(this.vendorAdjustmentModal.nativeElement, {
      backdrop: 'static',
      keyboard: false,
      focus: true
    });
    modal.show();
  }

  onDelete(rowData: any, event: Event): void {
    event.stopPropagation();

    const adjId = rowData.AdjId;

    if (!adjId) {
      this.toastr.warning('Invalid adjustment selected.', '', this.sharedHTMLSettings.ToasterConfig);
      return;
    }

    Swal.fire({
      title: 'Confirm',
      text: 'Are you sure you want to delete this adjustment?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.subscriptions.push(
          this.posvendoradjustmentservice
            .deleteVendorAdjustment(adjId)
            .subscribe({
              next: (res) => {
                if (res?.Success) {
                  this.toastr.success(
                    res?.Message || `${this.fieldName} adjustment deleted successfully.`,
                    '',
                    this.sharedHTMLSettings.ToasterConfig
                  );
                  this.getPosVendorAdjDetails();
                } else {
                  this.toastr.warning(
                    res?.Message || `Unable to delete ${this.fieldName} adjustment.`,
                    '',
                    this.sharedHTMLSettings.ToasterConfig
                  );
                }
              },
              error: () => {
                this.toastr.error(
                  `Failed to delete ${this.fieldName} adjustment.`,
                  '',
                  this.sharedHTMLSettings.ToasterConfig
                );
              }
            })
        );
      }
    });
  }

  private setupAmountCalculation(): void {
    this.VendorAdjustmentForm.get('cashPayment')?.valueChanges.subscribe(() => this.updateTotalAmount());
    this.VendorAdjustmentForm.get('checkPayment')?.valueChanges.subscribe(() => this.updateTotalAmount());
  }

  private updateTotalAmount(): void {
    const cash = parseFloat((this.VendorAdjustmentForm.get('cashPayment')?.value || '0').replace(/[^0-9.-]/g, '')) || 0;
    const check = parseFloat((this.VendorAdjustmentForm.get('checkPayment')?.value || '0').replace(/[^0-9.-]/g, '')) || 0;
    const total = (cash + check).toFixed(2);
    this.VendorAdjustmentForm.patchValue(
      { totalAmount: `$${total}` },
      { emitEvent: false });
  }

  routeBack(): void {
    if (this.VendorAdjustmentForm.dirty) {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Unsaved changes will be lost. Are you sure you want to continue?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['/Operations/VendorAdjustments']);
        }
      });
    } else {
      this.router.navigate(['/Operations/VendorAdjustments']);
    }
  }

  private showWarning(message: string) {
    Swal.fire({
      title: $localize`Warning`,
      text: message,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
  }

  getVendorById(): void {
    const vendorId = this.VendorAdjustmentForm.get('marketVendorId')?.value;

    if (!vendorId) {
      this.VendorAdjustmentForm.patchValue({ vendorName: '', vendorSeqId: '' });
      return;
    }

    this.subscriptions.push(
      this.vendorService.getVendorInfoByMarketVendorId(vendorId)
        .pipe(take(1))
        .subscribe((res) => {
          if (res?.VendorId) {
            this.VendorAdjustmentForm.patchValue({
              vendorSeqId: res.VendorId,
              vendorName: res.VendorName,
            });
          }
          else {
            this.VendorAdjustmentForm.patchValue({
              vendorSeqId: '',
              vendorName: '',
            });
            this.showWarning($localize`Vendor ID does not exist.`);
          }
        })
    );
  }

  onVendorSelected(vendor: any) {
    this.VendorAdjustmentForm.patchValue({
      marketVendorId: vendor.marketVendorId,
      vendorSeqId: vendor.vendorId,
      vendorName: vendor.vendorName
    });

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  onSave() {
    if (this.isEditMode && !this.VendorAdjustmentForm.dirty) {
      return;
    }

    const descriptionCtrl = this.VendorAdjustmentForm.get('description');
    descriptionCtrl?.setValue((descriptionCtrl.value || '').trim(), { emitEvent: false });
    descriptionCtrl?.updateValueAndValidity();

    const cashValue = (this.VendorAdjustmentForm.get('cashPayment')?.value || '0').replace(/[^0-9.-]/g, '');
    const checkValue = (this.VendorAdjustmentForm.get('checkPayment')?.value || '0').replace(/[^0-9.-]/g, '');
    const checkNumber = this.VendorAdjustmentForm.get('checkNumber')?.value?.trim() || '';

    const cash = parseFloat(cashValue) || 0;
    const check = parseFloat(checkValue) || 0;

    if (cash <= 0 && check <= 0) {
      this.toastr.warning('Please enter a valid amount', '', this.sharedHTMLSettings.ToasterConfig);
      return;
    }

    if (check > 0 && checkNumber === '') {
      this.toastr.warning('Please enter a check number for the check payment.', '', this.sharedHTMLSettings.ToasterConfig);
      return;
    }

    if (this.VendorAdjustmentForm.invalid) {
      this.toastr.warning('Please fill all required fields.', '', this.sharedHTMLSettings.ToasterConfig);
      return;
    }

    this.saveVendorAdjustment();
  }

  get fieldName(): string {
    return this.wordReplacePipe?.transform('Vendor') ?? 'Vendor';
  }

  get editRight(): boolean {
    return this.generalService
      ?.getUserPermissionsForModule(EUserSecurityFunctionID.VendorAdjustments)?.EditRight ?? false;
  }

  onCashPaymentBlur() {
    const ctrl = this.VendorAdjustmentForm.get('cashPayment');
    let value = parseFloat(ctrl?.value.replace(/[^0-9.-]/g, '')) || 0;
    ctrl?.setValue(`$${value.toFixed(2)}`, { emitEvent: false });
    this.updateTotalAmount();
  }

  onCheckPaymentBlur() {
    const ctrl = this.VendorAdjustmentForm.get('checkPayment');
    let value = parseFloat(ctrl?.value.replace(/[^0-9.-]/g, '')) || 0;
    ctrl?.setValue(`$${value.toFixed(2)}`, { emitEvent: false });
    this.updateTotalAmount();
  }

  enableDisableCheckNumber() {
    const check = parseFloat(
      String(this.VendorAdjustmentForm.get('checkPayment')?.value).replace(/[^0-9.]/g, '')
    ) || 0;

    const ctrl = this.VendorAdjustmentForm.get('checkNumber');

    if (check > 0) {
      ctrl?.enable({ emitEvent: false });
    } else {
      ctrl?.disable({ emitEvent: false });
      ctrl?.setValue('');
    }
  }

  numberOnly(event): boolean {
    return this.customCurrency.customCurrencyInput(event)
  }

  openVendorModal() {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const vendorModal = new bootstrap.Modal(
      document.getElementById('vendorSearchModal')!,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    vendorModal.show();
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  dataBound(args) {
    Object.assign((<any>this.gridPosVendorAdjustment.filterModule).filterOperators, { startsWith: 'contains' });
  }

  public created(args1) {
    this.gridPosVendorAdjustment.element.querySelectorAll('.e-filterdiv')[this.gridPosVendorAdjustment.getColumnIndexByField('SlNo')].classList.add('e-hide');
    this.gridPosVendorAdjustment.element.querySelectorAll('.e-filterdiv')[this.gridPosVendorAdjustment.getColumnIndexByField('CashPayment')].classList.add('e-hide');
    this.gridPosVendorAdjustment.element.querySelectorAll('.e-filterdiv')[this.gridPosVendorAdjustment.getColumnIndexByField('CheckPayment')].classList.add('e-hide');
    this.gridPosVendorAdjustment.element.querySelectorAll('.e-filterdiv')[this.gridPosVendorAdjustment.getColumnIndexByField('CheckNo')].classList.add('e-hide');
    this.gridPosVendorAdjustment.element.querySelectorAll('.e-filterdiv')[this.gridPosVendorAdjustment.getColumnIndexByField('TotalPayment')].classList.add('e-hide');
    this.gridPosVendorAdjustment.element.querySelectorAll('.e-filterdiv')[this.gridPosVendorAdjustment.getColumnIndexByField('Delete')].classList.add('e-hide');
    this.gridPosVendorAdjustment.filterSettings = { mode: 'Immediate', immediateModeDelay: 100 };
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
